import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import "./scss/manager-dashboard.scss";
import ManagerFooter from "../components/ManagerFooter";
import api from "../api";
import mapProduct from "../utils/mapProduct";
import ManagerProductCard from "../components/ProductCard";
import Icon from "../lib/icon";

const TAKE = 10;

export default function ManagerDashboardPage() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const pages = Math.ceil(total / TAKE);

  const load = async (pageNumber = 1) => {
    const skip = (pageNumber - 1) * TAKE;

    const { data } = await api.get("/api/manager/products", {
      params: { skip, take: TAKE }
    });

    setProducts(data.products.map(mapProduct));
    setTotal(data.total);
    setPage(pageNumber);
  };

  useEffect(() => {
    load(1);
  }, []);

  function getPages() {
    const maxVisible = 2; // сколько вокруг текущей
    const result = [];

    if (pages <= 1) return result;

    const left = Math.max(1, page - maxVisible);
    const right = Math.min(pages, page + maxVisible);

    // Первая страница
    if (left > 1) {
      result.push(1);
      if (left > 2) result.push("...");
    }

    for (let i = left; i <= right; i++) {
      result.push(i);
    }

    // Последняя страница
    if (right < pages) {
      if (right < pages - 1) result.push("...");
      result.push(pages);
    }

    // Убираем возможные дубликаты (на всякий случай)
    return [...new Set(result)];
  }

  return (
    <>
    <div className="manager-dashboard">

      {/* HEADER */}
      <div className="manager-dashboard__header">
        <span className="manager-dashboard__title">
          Кабинет менеджера
        </span>

        <button
          className="manager-dashboard__logout"
          onClick={() => navigate("/manager/login")}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4ZM16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L17.7071 16.7071C17.3166 17.0976 16.6834 17.0976 16.2929 16.7071C15.9024 16.3166 15.9024 15.6834 16.2929 15.2929L18.5858 13H11C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H18.5858L16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289Z" fill="#A1233C"/>
</svg>
        </button>
      </div>

      {/* ACTION CARDS */}
      <div className="manager-dashboard__actions">
        <div
          className="manager-dashboard__card"
          onClick={() => navigate("/manager/markets")}
        >
          <div className="manager-dashboard__card-left">
            <div className="manager-dashboard__card-icon">
              <Icon name="briefcase" color="#D62F50"></Icon>
            </div>
            <div className="manager-dashboard__card-text">
              <div>Магазин</div>
              <div className="manager-dashboard__card-button">
                <span>›</span>
              </div>
            </div>
          </div>

          
        </div>

        <div
          className="manager-dashboard__card"
          onClick={() => navigate("/manager/products")}
        >
          <div className="manager-dashboard__card-left">
            <div className="manager-dashboard__card-icon">
              
              <Icon name="cart" color="#D62F50"></Icon>
            </div>
            <div className="manager-dashboard__card-text">
              <div>Товары</div>
              <div className="manager-dashboard__card-button">
                <span>›</span>
              </div>
            </div>
          </div>

          
        </div>

      </div>

      {/* ADD BUTTON */}
      <div className="manager-dashboard__add">
        <Button
          className="btn-primary large"
          onClick={() => navigate("/manager/market")}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5Z" fill="white"/>
</svg>
 Добавить магазин
        </Button>
      </div>

      {/* PRODUCTS SECTION */}
      <div className="manager-dashboard__products">
          <div className="manager-dashboard__products-title">
            Товары на публикацию
          </div>

          <div className="manager-dashboard__products-list">
            {products.map(p => (
              <ManagerProductCard key={p.id} product={p} />
            ))}
          </div>

          {/* PAGINATION */}
          {pages > 1 && (
            <div className="manager-dashboard__pagination">

              {page > 1 && (
                <span onClick={() => load(page - 1)}>‹</span>
              )}

              {getPages().map((p, i) =>
                p === "..." ? (
                  <span key={i}>...</span>
                ) : (
                  <span
                    key={p}
                    className={page === p ? "active" : ""}
                    onClick={() => load(p)}
                  >
                    {p}
                  </span>
                )
              )}

              {page < pages && (
                <span onClick={() => load(page + 1)}>›</span>
              )}

            </div>
          )}
      </div>
    </div>
    <ManagerFooter />
    </>
  );
}
